import * as React from 'react';
export const PickerFieldPrivateContext = /*#__PURE__*/React.createContext(null);
export function useNullableFieldPrivateContext() {
  return React.useContext(PickerFieldPrivateContext);
}